const teamdata = [
  {
    name: "Pritam Kumar Sarangi",
    role: "Backend & Model Development",
    title: "Student - CSE",
    university: "SOA University Bhubaneswar",
    image: "/images/pritam.jpg", // Place image in public/images
    linkedin: "https://www.linkedin.com/in/pritam-kumar-sarangi-7b952a232/",
    github: "https://github.com/prrriiitam"
  },
  {
    name: "Dipendra Sah",
    role: "Reasearch, Litreature Survey",
    title: "Student - CSE",
    university: "SOA University Bhubaneswar",
    image: "/images/dipendra.png",
    linkedin: "https://www.linkedin.com/in/dipendra-sah-901266263/",
    github: "#"
  },
  {
    name: "P. Rohan Reddy",
    role: "Frontend",
    title: "Student - CSE",
    university: "SOA University Bhubaneswar",
    image: "/images/random.jpg",
    linkedin: "#",
    github: "#"
  },
    {
    name: "Deepankar Mahato",
    role: "Frontend",
    title: "Student - CSE",
    university: "SOA University Bhubaneswar",
    image: "/images/random2.jpg",
    linkedin: "#",
    github: "#"
  }
];

export default teamdata;
